import React, { useState, useEffect } from 'react';
import './Admin.css';
import { studyAPI } from '../api/study';

function Admin() {
  const [activeTab, setActiveTab] = useState('users');
  const [users, setUsers] = useState([]);
  const [poems, setPoems] = useState([]);
  const [exchangeItems, setExchangeItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [textbooks, setTextbooks] = useState([]);
  const [grades, setGrades] = useState([]);
  const [units, setUnits] = useState([]);
  const [otherCategories, setOtherCategories] = useState([]);
  const [categorySubItems, setCategorySubItems] = useState([]);
  const [selectedTextbook, setSelectedTextbook] = useState(null);
  const [selectedGrade, setSelectedGrade] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedSubItem, setSelectedSubItem] = useState(null);
  const [showPoemModal, setShowPoemModal] = useState(false);
  const [editingPoem, setEditingPoem] = useState(null);
  const [poemForm, setPoemForm] = useState({ title: '', author: '', dynasty: '', content: '', backgroundVideo: '', mindMapUrl: '', unitId: '', categorySubItemId: '' });
  const [textbookForm, setTextbookForm] = useState({ name: '', description: '' });
  const [editingTextbook, setEditingTextbook] = useState(null);
  const [showTextbookForm, setShowTextbookForm] = useState(false);
  const [gradeForm, setGradeForm] = useState({ name: '', description: '' });
  const [editingGrade, setEditingGrade] = useState(null);
  const [showGradeForm, setShowGradeForm] = useState(false);
  const [unitForm, setUnitForm] = useState({ name: '', description: '' });
  const [editingUnit, setEditingUnit] = useState(null);
  const [showUnitForm, setShowUnitForm] = useState(false);
  const [categoryForm, setCategoryForm] = useState({ name: '', description: '' });
  const [editingCategory, setEditingCategory] = useState(null);
  const [showCategoryForm, setShowCategoryForm] = useState(false);
  const [subItemForm, setSubItemForm] = useState({ name: '', description: '' });
  const [editingSubItem, setEditingSubItem] = useState(null);
  const [showSubItemForm, setShowSubItemForm] = useState(false);
  const [resetPasswordUser, setResetPasswordUser] = useState(null);
  const [resetPasswordValue, setResetPasswordValue] = useState('');
  const [showResetConfirm, setShowResetConfirm] = useState(false);
  const [showValidationModal, setShowValidationModal] = useState(false);
  const [validationMessage, setValidationMessage] = useState('');
  const [expandedNodes, setExpandedNodes] = useState({});
  const [poemTreeData, setPoemTreeData] = useState([]);
  const [showProductModal, setShowProductModal] = useState(false);
  const [editingProduct, setEditingProduct] = useState(null);
  const [productForm, setProductForm] = useState({ name: '', price: 0, stock: 0, description: '', image_url: '', status: 'available', detail_images: '' });
  const [productImageUploading, setProductImageUploading] = useState(false);
  const [productImagePreviewKey, setProductImagePreviewKey] = useState(0);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [deletingItemId, setDeletingItemId] = useState(null);

  const [isAdmin, setIsAdmin] = useState(false);
  const [isAdminChecked, setIsAdminChecked] = useState(false);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [loginForm, setLoginForm] = useState({ username: '', password: '' });
  const [loginLoading, setLoginLoading] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastType, setToastType] = useState('success');
  const [customConfirm, setCustomConfirm] = useState({ show: false, message: '', action: null });

  const getAdminHeaders = () => {
    const headers = { 'Content-Type': 'application/json' };
    const token = localStorage.getItem('token');
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    return headers;
  };

  const getAdminAuthHeaders = () => {
    const headers = {};
    const token = localStorage.getItem('token');
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    return headers;
  };

  const buildProductPayload = (form, id) => {
    const payload = {
      name: form.name,
      price: form.price,
      stock: form.stock,
      description: form.description,
      imageUrl: form.image_url || null,
      detailImages: form.detail_images || null,
      status: form.status || 'available'
    };
    if (id != null) {
      payload.id = id;
    }
    return payload;
  };

  const getProductImagePreviewSrc = (url) => {
    if (!url) return '';
    const separator = url.includes('?') ? '&' : '?';
    return `${url}${separator}v=${productImagePreviewKey || Date.now()}`;
  };

  const handleProductImageUpload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    if (!file.type.startsWith('image/')) {
      showToastMessage('请选择图片文件', 'error');
      e.target.value = '';
      return;
    }

    setProductImageUploading(true);
    try {
      const formData = new FormData();
      formData.append('image', file);
      const res = await fetch('/api/admin/product/upload-image', {
        method: 'POST',
        headers: getAdminAuthHeaders(),
        body: formData
      });
      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.message || '图片上传失败');
      }
      const data = await res.json();
      setProductImagePreviewKey(Date.now());
      setProductForm(prev => ({ ...prev, image_url: data.url }));
      showToastMessage('图片上传成功', 'success');
    } catch (error) {
      console.error('Failed to upload product image', error);
      showToastMessage(error.message || '图片上传失败，请重试', 'error');
    } finally {
      setProductImageUploading(false);
      e.target.value = '';
    }
  };

  const checkAdminAuth = async () => {
    setIsAdminChecked(true);
    const token = localStorage.getItem('token');
    if (!token) {
      setShowLoginModal(true);
      return;
    }
    try {
      const res = await fetch('/api/auth/me', { headers: getAdminHeaders() });
      if (!res.ok) {
        localStorage.removeItem('token');
        setShowLoginModal(true);
        return;
      }
      const data = await res.json();
      if (data.isAdmin) {
        setIsAdmin(true);
        setShowLoginModal(false);
      } else {
        setShowLoginModal(true);
      }
    } catch (error) {
      console.error('验证管理员身份失败', error);
      setShowLoginModal(true);
    }
  };

  const showToastMessage = (message, type = 'success') => {
    setToastMessage(message);
    setToastType(type);
    setShowToast(true);
    setTimeout(() => setShowToast(false), 3000);
  };

  const handleAdminLogin = async () => {
    if (!loginForm.username || !loginForm.password) {
      showToastMessage('请输入用户名和密码', 'error');
      return;
    }
    setLoginLoading(true);
    try {
      const res = await fetch('/api/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ phone: loginForm.username, password: loginForm.password })
      });
      const data = await res.json();
      if (res.ok && data.token) {
        if (data.isAdmin) {
          localStorage.setItem('token', data.token);
          setIsAdmin(true);
          setShowLoginModal(false);
          showToastMessage('管理员登录成功！', 'success');
          setLoginForm({ username: '', password: '' });
        } else {
          showToastMessage('该账户没有管理员权限', 'error');
        }
      } else {
        showToastMessage(data.message || '用户名或密码错误', 'error');
      }
    } catch (error) {
      console.error('登录失败', error);
      showToastMessage('登录失败，请重试', 'error');
    }
    setLoginLoading(false);
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    setIsAdmin(false);
    setShowLoginModal(true);
    setLoginForm({ username: '', password: '' });
  };

  const fetchUsers = async () => {
    setLoading(true);
    try {
      const res = await fetch('/api/admin/users', {
        headers: getAdminHeaders()
      });
      const data = await res.json();
      setUsers(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error('Failed to load users', error);
      setUsers([]);
    }
    setLoading(false);
  };

  const fetchPoems = async () => {
    try {
      const res = await fetch('/api/admin/study/poems', { headers: getAdminHeaders() });
      const data = await res.json();
      setPoems(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error('Failed to load poems', error);
      setPoems([]);
    }
  };

  const fetchPoemTree = async () => {
    try {
      const [textbooksRes, poemsRes, catsRes] = await Promise.all([
        fetch('/api/admin/study/textbooks', { headers: getAdminHeaders() }),
        fetch('/api/admin/study/poems', { headers: getAdminHeaders() }),
        fetch('/api/admin/study/other-categories', { headers: getAdminHeaders() })
      ]);
      const textbooks = await textbooksRes.json();
      const allPoems = await poemsRes.json();
      const categories = await catsRes.json();
      const tree = [];

      for (const tb of (Array.isArray(textbooks) ? textbooks : [])) {
        const gradesRes = await fetch(`/api/admin/study/textbooks/${tb.id}/grades`, { headers: getAdminHeaders() });
        const grades = await gradesRes.json();
        const tbNode = { id: `tb-${tb.id}`, type: 'textbook', name: tb.name, children: [] };
        for (const g of (Array.isArray(grades) ? grades : [])) {
          const unitsRes = await fetch(`/api/admin/study/grades/${g.id}/units`, { headers: getAdminHeaders() });
          const units = await unitsRes.json();
          const gNode = { id: `g-${g.id}`, type: 'grade', name: g.name, children: [] };
          for (const u of (Array.isArray(units) ? units : [])) {
            const uPoems = (Array.isArray(allPoems) ? allPoems : []).filter(p => p.unitId === u.id);
            const uNode = { id: `u-${u.id}`, type: 'unit', name: u.name, poems: uPoems };
            gNode.children.push(uNode);
          }
          tbNode.children.push(gNode);
        }
        tree.push(tbNode);
      }

      for (const cat of (Array.isArray(categories) ? categories : [])) {
        const subRes = await fetch(`/api/admin/study/other-categories/${cat.id}/sub-items`, { headers: getAdminHeaders() });
        const subs = await subRes.json();
        const catNode = { id: `cat-${cat.id}`, type: 'category', name: cat.name, children: [] };
        for (const s of (Array.isArray(subs) ? subs : [])) {
          const sPoems = (Array.isArray(allPoems) ? allPoems : []).filter(p => p.categorySubItemId === s.id);
          const sNode = { id: `s-${s.id}`, type: 'subitem', name: s.name, poems: sPoems };
          catNode.children.push(sNode);
        }
        tree.push(catNode);
      }

      setPoemTreeData(tree);
    } catch (error) {
      console.error('Failed to load poem tree', error);
    }
  };

  const fetchExchangeItems = async () => {
    setLoading(true);
    try {
      const res = await fetch('/api/admin/products', {
        headers: getAdminHeaders()
      });
      const data = await res.json();
      setExchangeItems(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error('Failed to load products', error);
      setExchangeItems([]);
    }
    setLoading(false);
  };

  useEffect(() => {
    checkAdminAuth();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const poemsRes = await studyAPI.getPoems({});
        setPoems(Array.isArray(poemsRes) ? poemsRes : []);
      } catch (error) {
        console.error('Failed to load poems', error);
        setPoems([]);
      }
      setLoading(false);
    };
    fetchData();
  }, []);

  useEffect(() => {
    if (!isAdmin) return;
    if (activeTab === 'users') {
      fetchUsers();
    } else if (activeTab === 'exchange') {
      fetchExchangeItems();
    } else if (activeTab === 'textbooks') {
      fetchTextbooks();
      fetchOtherCategories();
    } else if (activeTab === 'poems') {
      fetchPoemTree();
    }
  }, [activeTab, isAdmin]);

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  const handleEditPoem = (poem) => {
    openPoemModal('', '', poem);
  };

  const handleDeletePoem = (poemId) => {
    setCustomConfirm({
      show: true,
      message: '确定删除此古诗？',
      action: async () => {
        try {
          const res = await fetch(`/api/admin/study/poems/${poemId}`, {
            method: 'DELETE',
            headers: getAdminHeaders()
          });
          if (res.ok) {
            fetchPoems();
            fetchPoemTree();
          }
        } catch (error) {
          console.error('Failed to delete poem', error);
        }
      }
    });
  };

  const toggleNode = (nodeId) => {
    setExpandedNodes(prev => ({ ...prev, [nodeId]: !prev[nodeId] }));
  };

  const countNodePoems = (node) => {
    if (node.poems) return node.poems.length;
    if (node.children) {
      return node.children.reduce((sum, c) => sum + countNodePoems(c), 0);
    }
    return 0;
  };

  const handleResetPassword = async () => {
    setShowResetConfirm(false);
    if (!resetPasswordUser || !resetPasswordValue.trim()) return;
    try {
      const res = await fetch(`/api/admin/users/${resetPasswordUser.id}/reset-password`, {
        method: 'PUT',
        headers: getAdminHeaders(),
        body: JSON.stringify({ password: resetPasswordValue.trim() })
      });
      if (res.ok) {
        setValidationMessage('密码重置成功');
        setShowValidationModal(true);
        setResetPasswordUser(null);
        setResetPasswordValue('');
      } else {
        setValidationMessage('密码重置失败');
        setShowValidationModal(true);
      }
    } catch (error) {
      console.error('Failed to reset password', error);
      setValidationMessage('密码重置失败');
      setShowValidationModal(true);
    }
  };

  const handleCreatePoem = async () => {
    if (!poemForm.unitId && !poemForm.categorySubItemId) {
      setValidationMessage('请至少选择教材关联或其他分类关联');
      setShowValidationModal(true);
      return;
    }
    try {
      const res = await fetch('/api/admin/study/poems', {
        method: 'POST',
        headers: getAdminHeaders(),
        body: JSON.stringify(poemForm)
      });
      if (res.ok) {
        setPoemForm({ title: '', author: '', dynasty: '', content: '', backgroundVideo: '', mindMapUrl: '', unitId: '', categorySubItemId: '' });
        setShowPoemModal(false);
        fetchPoems();
      }
    } catch (error) {
      console.error('Failed to create poem', error);
    }
  };

  const handleUpdatePoem = async () => {
    if (!editingPoem) return;
    try {
      const res = await fetch(`/api/admin/study/poems/${editingPoem.id}`, {
        method: 'PUT',
        headers: getAdminHeaders(),
        body: JSON.stringify(poemForm)
      });
      if (res.ok) {
        setPoemForm({ title: '', author: '', dynasty: '', content: '', backgroundVideo: '', mindMapUrl: '', unitId: '', categorySubItemId: '' });
        setEditingPoem(null);
        setShowPoemModal(false);
        fetchPoems();
      }
    } catch (error) {
      console.error('Failed to update poem', error);
    }
  };

  const handleEditExchangeItem = (item) => {
    setProductForm({ name: item.name || '', price: item.price || 0, stock: item.stock || 0, description: item.description || '', image_url: item.imageUrl || '', status: item.status || 'available', detail_images: item.detailImages || '' });
    setProductImagePreviewKey(Date.now());
    setEditingProduct(item);
    setShowProductModal(true);
  };

  const handleDeleteExchangeItem = async (itemId) => {
    setDeletingItemId(itemId);
    setShowDeleteConfirm(true);
  };

  const confirmDeleteProduct = async () => {
    setShowDeleteConfirm(false);
    if (!deletingItemId) return;
    try {
      const res = await fetch(`/api/admin/product/${deletingItemId}`, {
        method: 'DELETE',
        headers: getAdminHeaders()
      });
      if (res.ok) fetchExchangeItems();
    } catch (error) {
      console.error('Failed to delete product', error);
    }
    setDeletingItemId(null);
  };

  const handleToggleProductStatus = async (item) => {
    try {
      const newStatus = item.status === 'available' || item.status === 'in-stock' ? 'off-stock' : 'available';
      const res = await fetch(`/api/admin/product/${item.id}/status`, {
        method: 'PUT',
        headers: getAdminHeaders(),
        body: JSON.stringify({ status: newStatus })
      });
      if (res.ok) {
        showToastMessage(`商品"${item.name}"已${newStatus === 'available' || newStatus === 'in-stock' ? '上架' : '下架'}`, 'success');
        fetchExchangeItems();
      }
    } catch (error) {
      console.error('Failed to update status', error);
    }
  };

  const handleCreateProduct = async () => {
    try {
      const res = await fetch('/api/admin/product', {
        method: 'POST',
        headers: getAdminHeaders(),
        body: JSON.stringify(buildProductPayload(productForm))
      });
      if (res.ok) {
        setProductForm({ name: '', price: 0, stock: 0, description: '', image_url: '', status: 'available', detail_images: '' });
        setShowProductModal(false);
        fetchExchangeItems();
      }
    } catch (error) {
      console.error('Failed to create product', error);
    }
  };

  const handleUpdateProduct = async () => {
    if (!editingProduct) return;
    try {
      const res = await fetch('/api/admin/product', {
        method: 'PUT',
        headers: getAdminHeaders(),
        body: JSON.stringify(buildProductPayload(productForm, editingProduct.id))
      });
      if (res.ok) {
        setProductForm({ name: '', price: 0, stock: 0, description: '', image_url: '', status: 'available', detail_images: '' });
        setEditingProduct(null);
        setShowProductModal(false);
        fetchExchangeItems();
      }
    } catch (error) {
      console.error('Failed to update product', error);
    }
  };

  const fetchTextbooks = async () => {
    setLoading(true);
    try {
      const res = await fetch('/api/admin/study/textbooks', { headers: getAdminHeaders() });
      const data = await res.json();
      setTextbooks(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error('Failed to load textbooks', error);
      setTextbooks([]);
    }
    setLoading(false);
  };

  const fetchGrades = async (textbookId) => {
    setLoading(true);
    try {
      const res = await fetch(`/api/admin/study/textbooks/${textbookId}/grades`, { headers: getAdminHeaders() });
      const data = await res.json();
      setGrades(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error('Failed to load grades', error);
      setGrades([]);
    }
    setLoading(false);
  };

  const fetchUnits = async (gradeId) => {
    setLoading(true);
    try {
      const res = await fetch(`/api/admin/study/grades/${gradeId}/units`, { headers: getAdminHeaders() });
      const data = await res.json();
      setUnits(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error('Failed to load units', error);
      setUnits([]);
    }
    setLoading(false);
  };

  const fetchOtherCategories = async () => {
    setLoading(true);
    try {
      const res = await fetch('/api/admin/study/other-categories', { headers: getAdminHeaders() });
      const data = await res.json();
      setOtherCategories(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error('Failed to load other categories', error);
      setOtherCategories([]);
    }
    setLoading(false);
  };

  const fetchSubItems = async (categoryId) => {
    setLoading(true);
    try {
      const res = await fetch(`/api/admin/study/other-categories/${categoryId}/sub-items`, { headers: getAdminHeaders() });
      const data = await res.json();
      setCategorySubItems(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error('Failed to load sub items', error);
      setCategorySubItems([]);
    }
    setLoading(false);
  };

  const handleCreateTextbook = async () => {
    try {
      const res = await fetch('/api/admin/study/textbooks', {
        method: 'POST',
        headers: getAdminHeaders(),
        body: JSON.stringify(textbookForm)
      });
      if (res.ok) {
        setTextbookForm({ name: '', description: '' });
        setShowTextbookForm(false);
        fetchTextbooks();
      }
    } catch (error) {
      console.error('Failed to create textbook', error);
    }
  };

  const handleUpdateTextbook = async () => {
    try {
      const res = await fetch(`/api/admin/study/textbooks/${editingTextbook.id}`, {
        method: 'PUT',
        headers: getAdminHeaders(),
        body: JSON.stringify(textbookForm)
      });
      if (res.ok) {
        setTextbookForm({ name: '', description: '' });
        setEditingTextbook(null);
        setShowTextbookForm(false);
        fetchTextbooks();
      }
    } catch (error) {
      console.error('Failed to update textbook', error);
    }
  };

  const handleDeleteTextbook = (id) => {
    setCustomConfirm({
      show: true,
      message: '确定删除此教材？',
      action: async () => {
        try {
          const res = await fetch(`/api/admin/study/textbooks/${id}`, {
            method: 'DELETE',
            headers: getAdminHeaders()
          });
          if (res.ok) fetchTextbooks();
        } catch (error) {
          console.error('Failed to delete textbook', error);
        }
      }
    });
  };

  const handleCreateGrade = async () => {
    try {
      const res = await fetch('/api/admin/study/grades', {
        method: 'POST',
        headers: getAdminHeaders(),
        body: JSON.stringify({ ...gradeForm, textbookId: selectedTextbook.id })
      });
      if (res.ok) {
        setGradeForm({ name: '', description: '' });
        setShowGradeForm(false);
        fetchGrades(selectedTextbook.id);
      }
    } catch (error) {
      console.error('Failed to create grade', error);
    }
  };

  const handleUpdateGrade = async () => {
    try {
      const res = await fetch(`/api/admin/study/grades/${editingGrade.id}`, {
        method: 'PUT',
        headers: getAdminHeaders(),
        body: JSON.stringify(gradeForm)
      });
      if (res.ok) {
        setGradeForm({ name: '', description: '' });
        setEditingGrade(null);
        setShowGradeForm(false);
        fetchGrades(selectedTextbook.id);
      }
    } catch (error) {
      console.error('Failed to update grade', error);
    }
  };

  const handleDeleteGrade = (id) => {
    setCustomConfirm({
      show: true,
      message: '确定删除此年级？',
      action: async () => {
        try {
          const res = await fetch(`/api/admin/study/grades/${id}`, {
            method: 'DELETE',
            headers: getAdminHeaders()
          });
          if (res.ok) fetchGrades(selectedTextbook.id);
        } catch (error) {
          console.error('Failed to delete grade', error);
        }
      }
    });
  };

  const handleCreateUnit = async () => {
    try {
      const res = await fetch('/api/admin/study/units', {
        method: 'POST',
        headers: getAdminHeaders(),
        body: JSON.stringify({ ...unitForm, gradeId: selectedGrade.id })
      });
      if (res.ok) {
        setUnitForm({ name: '', description: '' });
        setShowUnitForm(false);
        fetchUnits(selectedGrade.id);
      }
    } catch (error) {
      console.error('Failed to create unit', error);
    }
  };

  const handleUpdateUnit = async () => {
    try {
      const res = await fetch(`/api/admin/study/units/${editingUnit.id}`, {
        method: 'PUT',
        headers: getAdminHeaders(),
        body: JSON.stringify(unitForm)
      });
      if (res.ok) {
        setUnitForm({ name: '', description: '' });
        setEditingUnit(null);
        setShowUnitForm(false);
        fetchUnits(selectedGrade.id);
      }
    } catch (error) {
      console.error('Failed to update unit', error);
    }
  };

  const handleDeleteUnit = (id) => {
    setCustomConfirm({
      show: true,
      message: '确定删除此单元？',
      action: async () => {
        try {
          const res = await fetch(`/api/admin/study/units/${id}`, {
            method: 'DELETE',
            headers: getAdminHeaders()
          });
          if (res.ok) fetchUnits(selectedGrade.id);
        } catch (error) {
          console.error('Failed to delete unit', error);
        }
      }
    });
  };

  const handleCreateCategory = async () => {
    try {
      const res = await fetch('/api/admin/study/other-categories', {
        method: 'POST',
        headers: getAdminHeaders(),
        body: JSON.stringify(categoryForm)
      });
      if (res.ok) {
        setCategoryForm({ name: '', description: '' });
        setShowCategoryForm(false);
        fetchOtherCategories();
      }
    } catch (error) {
      console.error('Failed to create category', error);
    }
  };

  const handleUpdateCategory = async () => {
    try {
      const res = await fetch(`/api/admin/study/other-categories/${editingCategory.id}`, {
        method: 'PUT',
        headers: getAdminHeaders(),
        body: JSON.stringify(categoryForm)
      });
      if (res.ok) {
        setCategoryForm({ name: '', description: '' });
        setEditingCategory(null);
        setShowCategoryForm(false);
        fetchOtherCategories();
      }
    } catch (error) {
      console.error('Failed to update category', error);
    }
  };

  const handleDeleteCategory = (id) => {
    setCustomConfirm({
      show: true,
      message: '确定删除此分类？',
      action: async () => {
        try {
          const res = await fetch(`/api/admin/study/other-categories/${id}`, {
            method: 'DELETE',
            headers: getAdminHeaders()
          });
          if (res.ok) fetchOtherCategories();
        } catch (error) {
          console.error('Failed to delete category', error);
        }
      }
    });
  };

  const handleCreateSubItem = async () => {
    try {
      const res = await fetch('/api/admin/study/category-sub-items', {
        method: 'POST',
        headers: getAdminHeaders(),
        body: JSON.stringify({ ...subItemForm, categoryId: selectedCategory.id })
      });
      if (res.ok) {
        setSubItemForm({ name: '', description: '' });
        setShowSubItemForm(false);
        fetchSubItems(selectedCategory.id);
      }
    } catch (error) {
      console.error('Failed to create sub item', error);
    }
  };

  const handleUpdateSubItem = async () => {
    try {
      const res = await fetch(`/api/admin/study/category-sub-items/${editingSubItem.id}`, {
        method: 'PUT',
        headers: getAdminHeaders(),
        body: JSON.stringify(subItemForm)
      });
      if (res.ok) {
        setSubItemForm({ name: '', description: '' });
        setEditingSubItem(null);
        setShowSubItemForm(false);
        fetchSubItems(selectedCategory.id);
      }
    } catch (error) {
      console.error('Failed to update sub item', error);
    }
  };

  const handleDeleteSubItem = (id) => {
    setCustomConfirm({
      show: true,
      message: '确定删除此子项？',
      action: async () => {
        try {
          const res = await fetch(`/api/admin/study/category-sub-items/${id}`, {
            method: 'DELETE',
            headers: getAdminHeaders()
          });
          if (res.ok) fetchSubItems(selectedCategory.id);
        } catch (error) {
          console.error('Failed to delete sub item', error);
        }
      }
    });
  };

  const openPoemModal = async (unitId, categorySubItemId, poem) => {
    if (poem) {
      setPoemForm({
        title: poem.title || '',
        author: poem.author || '',
        dynasty: poem.dynasty || '',
        content: poem.content || '',
        backgroundVideo: poem.backgroundVideo || '',
        mindMapUrl: poem.mindMapUrl || '',
        unitId: poem.unitId || '',
        categorySubItemId: poem.categorySubItemId || ''
      });
      setEditingPoem(poem);

      if (poem.unitId) {
        const allTextbooksRes = await fetch('/api/admin/study/textbooks', { headers: getAdminHeaders() });
        const allTextbooks = await allTextbooksRes.json();
        setTextbooks(Array.isArray(allTextbooks) ? allTextbooks : []);
        let foundUnit = false;
        for (const tb of allTextbooks) {
          const gradesRes = await fetch(`/api/admin/study/textbooks/${tb.id}/grades`, { headers: getAdminHeaders() });
          const allGrades = await gradesRes.json();
          for (const g of allGrades) {
            const unitsRes = await fetch(`/api/admin/study/grades/${g.id}/units`, { headers: getAdminHeaders() });
            const allUnits = await unitsRes.json();
            const found = allUnits.find(u => u.id === poem.unitId);
            if (found) {
              setSelectedTextbook(tb);
              setGrades(allGrades);
              setSelectedGrade(g);
              setUnits(allUnits);
              foundUnit = true;
              break;
            }
          }
          if (foundUnit) break;
        }
      } else {
        setSelectedTextbook(null);
        setSelectedGrade(null);
        setGrades([]);
        setUnits([]);
      }

      if (poem.categorySubItemId) {
        const catsRes = await fetch('/api/admin/study/other-categories', { headers: getAdminHeaders() });
        const allCats = await catsRes.json();
        setOtherCategories(Array.isArray(allCats) ? allCats : []);
        let foundSub = false;
        for (const cat of allCats) {
          const subRes = await fetch(`/api/admin/study/other-categories/${cat.id}/sub-items`, { headers: getAdminHeaders() });
          const allSubs = await subRes.json();
          const found = allSubs.find(s => s.id === poem.categorySubItemId);
          if (found) {
            setSelectedCategory(cat);
            setCategorySubItems(allSubs);
            setSelectedSubItem(found);
            foundSub = true;
            break;
          }
        }
        if (!foundSub) {
          setSelectedCategory(null);
          setCategorySubItems([]);
        }
      } else {
        setSelectedCategory(null);
        setCategorySubItems([]);
      }
    } else {
      setPoemForm({ title: '', author: '', dynasty: '', content: '', backgroundVideo: '', mindMapUrl: '', unitId: unitId || '', categorySubItemId: categorySubItemId || '' });
      setEditingPoem(null);
      setSelectedTextbook(null);
      setSelectedGrade(null);
      setSelectedCategory(null);
      setSelectedSubItem(null);
      setGrades([]);
      setUnits([]);
      setCategorySubItems([]);
    }
    setShowPoemModal(true);
  };

  const handlePoemTextbookChange = async (textbookId) => {
    const textbook = textbooks.find(t => t.id === parseInt(textbookId));
    setSelectedTextbook(textbook || null);
    setSelectedGrade(null);
    setGrades([]);
    setUnits([]);
    setPoemForm({ ...poemForm, unitId: '' });
    if (textbookId) {
      await fetchGrades(textbookId);
    }
  };

  const handlePoemGradeChange = async (gradeId) => {
    const grade = grades.find(g => g.id === parseInt(gradeId));
    setSelectedGrade(grade || null);
    setUnits([]);
    setPoemForm({ ...poemForm, unitId: '' });
    if (gradeId) {
      await fetchUnits(gradeId);
    }
  };

  const handlePoemUnitChange = (unitId) => {
    setPoemForm({ ...poemForm, unitId: unitId });
  };

  const handlePoemCategoryChange = async (categoryId) => {
    const category = otherCategories.find(c => c.id === parseInt(categoryId));
    setSelectedCategory(category || null);
    setSelectedSubItem(null);
    setCategorySubItems([]);
    setPoemForm({ ...poemForm, categorySubItemId: '' });
    if (categoryId) {
      await fetchSubItems(categoryId);
    }
  };

  const handlePoemSubItemChange = (subItemId) => {
    setPoemForm({ ...poemForm, categorySubItemId: subItemId });
  };

  return (
    <div className="admin-container">
      {showToast && (
        <div className={`admin-toast admin-toast-${toastType}`}>
          {toastMessage}
        </div>
      )}

      {!isAdmin ? (
        <div className="admin-login-wrapper">
          <div className="admin-login-card">
            <h2 className="admin-login-title">管理员登录</h2>
            <div className="admin-login-form">
              <input
                type="text"
                placeholder="用户名（手机号）"
                value={loginForm.username}
                onChange={e => setLoginForm({ ...loginForm, username: e.target.value })}
                onKeyDown={e => e.key === 'Enter' && handleAdminLogin()}
              />
              <input
                type="password"
                placeholder="密码"
                value={loginForm.password}
                onChange={e => setLoginForm({ ...loginForm, password: e.target.value })}
                onKeyDown={e => e.key === 'Enter' && handleAdminLogin()}
              />
              <button
                className="admin-login-btn"
                onClick={handleAdminLogin}
                disabled={loginLoading}
              >
                {loginLoading ? '登录中...' : '登录'}
              </button>
            </div>
          </div>
        </div>
      ) : (
        <>
          <div className="admin-header">
            <h2>系统管理</h2>
            <button className="admin-logout-btn" onClick={handleLogout}>退出登录</button>
          </div>

          <div className="admin-content">
            <div className="admin-tabs">
              <button
                className={`admin-tab ${activeTab === 'users' ? 'active' : ''}`}
                onClick={() => handleTabChange('users')}
              >
                用户管理
              </button>
              <button
                className={`admin-tab ${activeTab === 'poems' ? 'active' : ''}`}
                onClick={() => handleTabChange('poems')}
              >
                古诗管理
              </button>
              <button
                className={`admin-tab ${activeTab === 'exchange' ? 'active' : ''}`}
                onClick={() => handleTabChange('exchange')}
              >
                兑换管理
              </button>
              <button
                className={`admin-tab ${activeTab === 'textbooks' ? 'active' : ''}`}
                onClick={() => handleTabChange('textbooks')}
              >
                教材管理
              </button>
            </div>

            <div className="admin-tab-content">
              {activeTab === 'users' && (
                <div>
                  <h3>用户列表</h3>
                  {loading ? <p>加载中...</p> : (
                    <table className="users-table">
                      <thead>
                        <tr>
                          <th>ID</th>
                          <th>手机号</th>
                          <th>积分</th>
                          <th>学习时长</th>
                          <th>操作</th>
                        </tr>
                      </thead>
                      <tbody>
                        {users.map(user => (
                          <tr key={user.id}>
                            <td>{user.id}</td>
                            <td>{user.phone}</td>
                            <td>{user.score}</td>
                            <td>{user.studyTime} 分钟</td>
                            <td>
                              <button className="reset-btn" onClick={() => { setResetPasswordUser(user); setResetPasswordValue(''); }}>重置密码</button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  )}
                </div>
              )}

              {activeTab === 'poems' && (
                <div>
                  <h3>古诗管理</h3>
                  <button className="add-btn" onClick={() => openPoemModal('', '')}>添加古诗</button>
                  {loading ? <p>加载中...</p> : (
                    <div className="poem-tree">
                      {poemTreeData.map(node => (
                        <div key={node.id}>
                          <div className={`tree-row tree-row-${node.type}`} onClick={() => toggleNode(node.id)}>
                            <span className="tree-toggle">{expandedNodes[node.id] ? '▼' : '▶'}</span>
                            <span className="tree-icon">{node.type === 'textbook' ? '📚' : node.type === 'grade' ? '🎓' : node.type === 'unit' ? '📖' : node.type === 'category' ? '🏷️' : '📝'}</span>
                            <span className="tree-label">{node.type === 'textbook' || node.type === 'category' ? (node.type === 'textbook' ? '教材' : '分类') : ''}</span>
                            <span className="tree-name">{node.name}</span>
                            <span className="tree-count">{countNodePoems(node)}首</span>
                          </div>
                          {expandedNodes[node.id] && node.children && node.children.map(child => (
                            <div key={child.id} className="tree-child">
                              <div className={`tree-row tree-row-${child.type}`} onClick={() => toggleNode(child.id)}>
                                <span className="tree-toggle">{expandedNodes[child.id] ? '▼' : '▶'}</span>
                                <span className="tree-icon">{child.type === 'grade' ? '🎓' : '📝'}</span>
                                <span className="tree-label">{child.type === 'grade' ? '年级' : '子项'}</span>
                                <span className="tree-name">{child.name}</span>
                                <span className="tree-count">{countNodePoems(child)}首</span>
                              </div>
                              {expandedNodes[child.id] && child.children && child.children.map(grandchild => (
                                <div key={grandchild.id} className="tree-grandchild">
                                  <div className={`tree-row tree-row-${grandchild.type}`}>
                                    <span className="tree-icon">{grandchild.type === 'unit' ? '📖' : '📝'}</span>
                                    <span className="tree-name">{grandchild.name}</span>
                                    <span className="tree-count">{grandchild.poems ? grandchild.poems.length : 0}首</span>
                                  </div>
                                  {grandchild.poems && grandchild.poems.length > 0 && (
                                    <div className="tree-poems">
                                      {grandchild.poems.map(poem => (
                                        <div key={poem.id} className="tree-poem-row">
                                          <span className="tree-poem-title">{poem.title}</span>
                                          <span className="tree-poem-author">{poem.author}</span>
                                          <span className="tree-poem-actions">
                                            <button className="edit-btn small" onClick={() => handleEditPoem(poem)}>编辑</button>
                                            <button className="delete-btn small" onClick={() => handleDeletePoem(poem.id)}>删除</button>
                                          </span>
                                        </div>
                                      ))}
                                    </div>
                                  )}
                                </div>
                              ))}
                              {child.poems && child.poems.length > 0 && (
                                <div className="tree-poems">
                                  {child.poems.map(poem => (
                                    <div key={poem.id} className="tree-poem-row">
                                      <span className="tree-poem-title">{poem.title}</span>
                                      <span className="tree-poem-author">{poem.author}</span>
                                      <span className="tree-poem-actions">
                                        <button className="edit-btn small" onClick={() => handleEditPoem(poem)}>编辑</button>
                                        <button className="delete-btn small" onClick={() => handleDeletePoem(poem.id)}>删除</button>
                                      </span>
                                    </div>
                                  ))}
                                </div>
                              )}
                            </div>
                          ))}
                          {node.poems && node.poems.length > 0 && (
                            <div className="tree-poems">
                              {node.poems.map(poem => (
                                <div key={poem.id} className="tree-poem-row">
                                  <span className="tree-poem-title">{poem.title}</span>
                                  <span className="tree-poem-author">{poem.author}</span>
                                  <span className="tree-poem-actions">
                                    <button className="edit-btn small" onClick={() => handleEditPoem(poem)}>编辑</button>
                                    <button className="delete-btn small" onClick={() => handleDeletePoem(poem.id)}>删除</button>
                                  </span>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              )}

              {activeTab === 'exchange' && (
                <div>
                  <h3>兑换商品管理</h3>
                  <button className="add-btn" onClick={() => { setProductForm({ name: '', price: 0, stock: 0, description: '', image_url: '', status: 'available', detail_images: '' }); setEditingProduct(null); setShowProductModal(true); }}>添加商品</button>
                  {loading ? <p>加载中...</p> : (
                    <table className="exchange-table">
                      <thead>
                        <tr>
                          <th>ID</th>
                          <th>名称</th>
                          <th>所需积分</th>
                          <th>库存</th>
                          <th>描述</th>
                          <th>状态</th>
                          <th>操作</th>
                        </tr>
                      </thead>
                      <tbody>
                        {exchangeItems.map(item => (
                          <tr key={item.id}>
                            <td>{item.id}</td>
                            <td>{item.name}</td>
                            <td>{item.price}</td>
                            <td>{item.stock}</td>
                            <td>{item.description ? (item.description.length > 30 ? item.description.substring(0, 30) + '...' : item.description) : '-'}</td>
                            <td>
                              <span className={`status-badge status-${item.status === 'available' || item.status === 'in-stock' ? 'on' : 'off'}`}>
                                {item.status === 'available' || item.status === 'in-stock' ? '上架' : '下架'}
                              </span>
                            </td>
                            <td>
                              <button className="edit-btn" onClick={() => handleEditExchangeItem(item)}>编辑</button>
                              <button className="status-btn" onClick={() => handleToggleProductStatus(item)}>
                                {item.status === 'available' || item.status === 'in-stock' ? '下架' : '上架'}
                              </button>
                              <button className="delete-btn" onClick={() => handleDeleteExchangeItem(item.id)}>删除</button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  )}
                  <hr style={{ margin: '20px 0' }} />
                  <OrderManagement />
                </div>
              )}

              {activeTab === 'textbooks' && (
                <div>
                  <h3>教材管理</h3>

                  {!selectedTextbook && (
                    <div>
                      <button className="add-btn" onClick={() => { setShowTextbookForm(true); setEditingTextbook(null); setTextbookForm({ name: '', description: '' }); }}>添加教材</button>
                      {showTextbookForm && (
                        <div className="form-container">
                          <input type="text" placeholder="教材名称" value={textbookForm.name} onChange={e => setTextbookForm({...textbookForm, name: e.target.value})} />
                          <input type="text" placeholder="描述" value={textbookForm.description} onChange={e => setTextbookForm({...textbookForm, description: e.target.value})} />
                          <button onClick={editingTextbook ? handleUpdateTextbook : handleCreateTextbook}>{editingTextbook ? '更新' : '创建'}</button>
                          <button onClick={() => setShowTextbookForm(false)}>取消</button>
                        </div>
                      )}
                      {loading ? <p>加载中...</p> : (
                        <table className="textbooks-table">
                          <thead>
                            <tr><th>ID</th><th>名称</th><th>描述</th><th>操作</th></tr>
                          </thead>
                          <tbody>
                            {textbooks.map(tb => (
                              <tr key={tb.id}>
                                <td>{tb.id}</td>
                                <td>{tb.name}</td>
                                <td>{tb.description || '-'}</td>
                                <td>
                                  <button className="view-btn" onClick={() => { setSelectedTextbook(tb); fetchGrades(tb.id); }}>查看年级</button>
                                  <button className="edit-btn" onClick={() => { setEditingTextbook(tb); setTextbookForm({ name: tb.name, description: tb.description || '' }); setShowTextbookForm(true); }}>编辑</button>
                                  <button className="delete-btn" onClick={() => handleDeleteTextbook(tb.id)}>删除</button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      )}
                    </div>
                  )}

                  {selectedTextbook && !selectedGrade && (
                    <div>
                      <button className="back-btn" onClick={() => { setSelectedTextbook(null); setGrades([]); }}>返回教材列表</button>
                      <h4>{selectedTextbook.name} - 年级列表</h4>
                      <button className="add-btn" onClick={() => { setShowGradeForm(true); setEditingGrade(null); setGradeForm({ name: '', description: '' }); }}>添加年级</button>
                      {showGradeForm && (
                        <div className="form-container">
                          <input type="text" placeholder="年级名称" value={gradeForm.name} onChange={e => setGradeForm({...gradeForm, name: e.target.value})} />
                          <input type="text" placeholder="描述" value={gradeForm.description} onChange={e => setGradeForm({...gradeForm, description: e.target.value})} />
                          <button onClick={editingGrade ? handleUpdateGrade : handleCreateGrade}>{editingGrade ? '更新' : '创建'}</button>
                          <button onClick={() => setShowGradeForm(false)}>取消</button>
                        </div>
                      )}
                      {loading ? <p>加载中...</p> : (
                        <table className="grades-table">
                          <thead>
                            <tr><th>ID</th><th>名称</th><th>描述</th><th>操作</th></tr>
                          </thead>
                          <tbody>
                            {grades.map(g => (
                              <tr key={g.id}>
                                <td>{g.id}</td>
                                <td>{g.name}</td>
                                <td>{g.description || '-'}</td>
                                <td>
                                  <button className="view-btn" onClick={() => { setSelectedGrade(g); fetchUnits(g.id); }}>查看单元</button>
                                  <button className="edit-btn" onClick={() => { setEditingGrade(g); setGradeForm({ name: g.name, description: g.description || '' }); setShowGradeForm(true); }}>编辑</button>
                                  <button className="delete-btn" onClick={() => handleDeleteGrade(g.id)}>删除</button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      )}
                    </div>
                  )}

                  {selectedTextbook && selectedGrade && (
                    <div>
                      <button className="back-btn" onClick={() => { setSelectedGrade(null); setUnits([]); }}>返回年级列表</button>
                      <h4>{selectedGrade.name} - 单元列表</h4>
                      <button className="add-btn" onClick={() => { setShowUnitForm(true); setEditingUnit(null); setUnitForm({ name: '', description: '' }); }}>添加单元</button>
                      <button className="add-btn" onClick={() => openPoemModal(selectedGrade.id, null)}>添加古诗</button>
                      {showUnitForm && (
                        <div className="form-container">
                          <input type="text" placeholder="单元名称" value={unitForm.name} onChange={e => setUnitForm({...unitForm, name: e.target.value})} />
                          <input type="text" placeholder="描述" value={unitForm.description} onChange={e => setUnitForm({...unitForm, description: e.target.value})} />
                          <button onClick={editingUnit ? handleUpdateUnit : handleCreateUnit}>{editingUnit ? '更新' : '创建'}</button>
                          <button onClick={() => setShowUnitForm(false)}>取消</button>
                        </div>
                      )}
                      {loading ? <p>加载中...</p> : (
                        <table className="units-table">
                          <thead>
                            <tr><th>ID</th><th>名称</th><th>描述</th><th>操作</th></tr>
                          </thead>
                          <tbody>
                            {units.map(u => (
                              <tr key={u.id}>
                                <td>{u.id}</td>
                                <td>{u.name}</td>
                                <td>{u.description || '-'}</td>
                                <td>
                                  <button className="edit-btn" onClick={() => { setEditingUnit(u); setUnitForm({ name: u.name, description: u.description || '' }); setShowUnitForm(true); }}>编辑</button>
                                  <button className="delete-btn" onClick={() => handleDeleteUnit(u.id)}>删除</button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      )}
                    </div>
                  )}

                  <hr style={{ margin: '20px 0' }} />

                  <h3>其他分类管理</h3>

                  {!selectedCategory && (
                    <div>
                      <button className="add-btn" onClick={() => { setShowCategoryForm(true); setEditingCategory(null); setCategoryForm({ name: '', description: '' }); }}>添加分类</button>
                      {showCategoryForm && (
                        <div className="form-container">
                          <input type="text" placeholder="分类名称" value={categoryForm.name} onChange={e => setCategoryForm({...categoryForm, name: e.target.value})} />
                          <input type="text" placeholder="描述" value={categoryForm.description} onChange={e => setCategoryForm({...categoryForm, description: e.target.value})} />
                          <button onClick={editingCategory ? handleUpdateCategory : handleCreateCategory}>{editingCategory ? '更新' : '创建'}</button>
                          <button onClick={() => setShowCategoryForm(false)}>取消</button>
                        </div>
                      )}
                      {loading ? <p>加载中...</p> : (
                        <table className="categories-table">
                          <thead>
                            <tr><th>ID</th><th>名称</th><th>描述</th><th>操作</th></tr>
                          </thead>
                          <tbody>
                            {otherCategories.map(cat => (
                              <tr key={cat.id}>
                                <td>{cat.id}</td>
                                <td>{cat.name}</td>
                                <td>{cat.description || '-'}</td>
                                <td>
                                  <button className="view-btn" onClick={() => { setSelectedCategory(cat); fetchSubItems(cat.id); }}>查看子项</button>
                                  <button className="edit-btn" onClick={() => { setEditingCategory(cat); setCategoryForm({ name: cat.name, description: cat.description || '' }); setShowCategoryForm(true); }}>编辑</button>
                                  <button className="delete-btn" onClick={() => handleDeleteCategory(cat.id)}>删除</button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      )}
                    </div>
                  )}

                  {selectedCategory && (
                    <div>
                      <button className="back-btn" onClick={() => { setSelectedCategory(null); setCategorySubItems([]); }}>返回分类列表</button>
                      <h4>{selectedCategory.name} - 子项列表</h4>
                      <button className="add-btn" onClick={() => { setShowSubItemForm(true); setEditingSubItem(null); setSubItemForm({ name: '', description: '' }); }}>添加子项</button>
                      <button className="add-btn" onClick={() => openPoemModal(null, selectedCategory.id)}>添加古诗</button>
                      {showSubItemForm && (
                        <div className="form-container">
                          <input type="text" placeholder="子项名称" value={subItemForm.name} onChange={e => setSubItemForm({...subItemForm, name: e.target.value})} />
                          <input type="text" placeholder="描述" value={subItemForm.description} onChange={e => setSubItemForm({...subItemForm, description: e.target.value})} />
                          <button onClick={editingSubItem ? handleUpdateSubItem : handleCreateSubItem}>{editingSubItem ? '更新' : '创建'}</button>
                          <button onClick={() => setShowSubItemForm(false)}>取消</button>
                        </div>
                      )}
                      {loading ? <p>加载中...</p> : (
                        <table className="subitems-table">
                          <thead>
                            <tr><th>ID</th><th>名称</th><th>描述</th><th>操作</th></tr>
                          </thead>
                          <tbody>
                            {categorySubItems.map(si => (
                              <tr key={si.id}>
                                <td>{si.id}</td>
                                <td>{si.name}</td>
                                <td>{si.description || '-'}</td>
                                <td>
                                  <button className="edit-btn" onClick={() => { setEditingSubItem(si); setSubItemForm({ name: si.name, description: si.description || '' }); setShowSubItemForm(true); }}>编辑</button>
                                  <button className="delete-btn" onClick={() => handleDeleteSubItem(si.id)}>删除</button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      )}
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>

          {showPoemModal && (
            <div className="modal-overlay" onClick={() => setShowPoemModal(false)}>
              <div className="modal-content lively-modal" onClick={e => e.stopPropagation()}>
                <h3 className="modal-title">{editingPoem ? '编辑古诗' : '添加古诗'}</h3>
                <div className="form-container">
                  <label className="form-label">标题</label>
                  <input type="text" placeholder="请输入古诗标题" value={poemForm.title} onChange={e => setPoemForm({...poemForm, title: e.target.value})} />
                  <label className="form-label">作者</label>
                  <input type="text" placeholder="请输入作者" value={poemForm.author} onChange={e => setPoemForm({...poemForm, author: e.target.value})} />
                  <label className="form-label">朝代</label>
                  <input type="text" placeholder="请输入朝代" value={poemForm.dynasty} onChange={e => setPoemForm({...poemForm, dynasty: e.target.value})} />
                  <label className="form-label">内容</label>
                  <textarea placeholder="请输入古诗内容" value={poemForm.content} onChange={e => setPoemForm({...poemForm, content: e.target.value})} />
                  <label className="form-label">背景视频URL</label>
                  <input type="text" placeholder="请输入背景视频URL" value={poemForm.backgroundVideo} onChange={e => setPoemForm({...poemForm, backgroundVideo: e.target.value})} />
                  <label className="form-label">思维导图URL</label>
                  <input type="text" placeholder="请输入思维导图URL" value={poemForm.mindMapUrl} onChange={e => setPoemForm({...poemForm, mindMapUrl: e.target.value})} />

                  <div className="cascade-section">
                    <h4>教材关联</h4>
                    <select value={selectedTextbook ? selectedTextbook.id : ''} onChange={e => handlePoemTextbookChange(e.target.value)}>
                      <option value="">选择教材</option>
                      {textbooks.map(tb => (
                        <option key={tb.id} value={tb.id}>{tb.name}</option>
                      ))}
                    </select>
                    <select value={selectedGrade ? selectedGrade.id : ''} onChange={e => handlePoemGradeChange(e.target.value)} disabled={!selectedTextbook}>
                      <option value="">选择年级</option>
                      {grades.map(g => (
                        <option key={g.id} value={g.id}>{g.name}</option>
                      ))}
                    </select>
                    <select value={poemForm.unitId} onChange={e => handlePoemUnitChange(e.target.value)} disabled={!selectedGrade}>
                      <option value="">选择单元</option>
                      {units.map(u => (
                        <option key={u.id} value={u.id}>{u.name}</option>
                      ))}
                    </select>
                  </div>

                  <div className="cascade-divider">
                    <span>或</span>
                  </div>

                  <div className="cascade-section">
                    <h4>其他分类关联</h4>
                    <select value={selectedCategory ? selectedCategory.id : ''} onChange={e => handlePoemCategoryChange(e.target.value)}>
                      <option value="">选择分类</option>
                      {otherCategories.map(cat => (
                        <option key={cat.id} value={cat.id}>{cat.name}</option>
                      ))}
                    </select>
                    <select value={poemForm.categorySubItemId} onChange={e => handlePoemSubItemChange(e.target.value)} disabled={!selectedCategory}>
                      <option value="">选择子项</option>
                      {categorySubItems.map(si => (
                        <option key={si.id} value={si.id}>{si.name}</option>
                      ))}
                    </select>
                  </div>

                  <div className="modal-actions">
                    <button className="lively-btn confirm-btn" onClick={editingPoem ? handleUpdatePoem : handleCreatePoem}>{editingPoem ? '更新' : '创建'}</button>
                    <button className="lively-btn cancel-btn" onClick={() => setShowPoemModal(false)}>取消</button>
                  </div>
                </div>
              </div>
            </div>
          )}

          {resetPasswordUser && (
            <div className="modal-overlay" onClick={() => { setResetPasswordUser(null); setResetPasswordValue(''); }}>
              <div className="modal-content lively-modal reset-password-modal" onClick={e => e.stopPropagation()}>
                <h3 className="modal-title">重置密码</h3>
                <div className="form-container">
                  <p className="reset-user-info">用户手机号: <strong>{resetPasswordUser.phone}</strong></p>
                  <input
                    type="text"
                    placeholder="请输入新密码"
                    value={resetPasswordValue}
                    onChange={e => setResetPasswordValue(e.target.value)}
                  />
                  <div className="modal-actions">
                    <button className="lively-btn confirm-btn" onClick={() => {
                      if (resetPasswordUser && resetPasswordValue.trim()) {
                        setShowResetConfirm(true);
                      }
                    }}>确认重置</button>
                    <button className="lively-btn cancel-btn" onClick={() => { setResetPasswordUser(null); setResetPasswordValue(''); }}>取消</button>
                  </div>
                </div>
              </div>
            </div>
          )}

          {showResetConfirm && resetPasswordUser && (
            <div className="modal-overlay" onClick={() => setShowResetConfirm(false)}>
              <div className="modal-content lively-modal reset-confirm-modal" onClick={e => e.stopPropagation()}>
                <h3 className="modal-title">确认重置</h3>
                <div className="form-container">
                  <p className="confirm-message">确定重置用户 <strong>{resetPasswordUser.phone}</strong> 的密码为 <strong>{resetPasswordValue}</strong> 吗？</p>
                  <div className="modal-actions">
                    <button className="lively-btn confirm-btn" onClick={handleResetPassword}>确定</button>
                    <button className="lively-btn cancel-btn" onClick={() => setShowResetConfirm(false)}>取消</button>
                  </div>
                </div>
              </div>
            </div>
          )}

          {showValidationModal && (
            <div className="modal-overlay" onClick={() => setShowValidationModal(false)}>
              <div className="modal-content lively-modal validation-modal" onClick={e => e.stopPropagation()}>
                <h3 className="modal-title">提示</h3>
                <div className="form-container">
                  <p className="validation-message">{validationMessage}</p>
                  <div className="modal-actions">
                    <button className="lively-btn confirm-btn" onClick={() => setShowValidationModal(false)}>确定</button>
                  </div>
                </div>
              </div>
            </div>
          )}

          {showDeleteConfirm && (
            <div className="modal-overlay" onClick={() => { setShowDeleteConfirm(false); setDeletingItemId(null); }}>
              <div className="modal-content lively-modal delete-confirm-modal" onClick={e => e.stopPropagation()}>
                <h3 className="modal-title">确认删除</h3>
                <div className="form-container">
                  <p className="delete-message">确定删除此商品？此操作不可撤销。</p>
                  <div className="modal-actions">
                    <button className="lively-btn confirm-btn danger" onClick={confirmDeleteProduct}>确定删除</button>
                    <button className="lively-btn cancel-btn" onClick={() => { setShowDeleteConfirm(false); setDeletingItemId(null); }}>取消</button>
                  </div>
                </div>
              </div>
            </div>
          )}

          {showProductModal && (
            <div className="modal-overlay" onClick={() => { setShowProductModal(false); setEditingProduct(null); }}>
              <div className="modal-content lively-modal product-modal" onClick={e => e.stopPropagation()}>
                <h3 className="modal-title">{editingProduct ? '编辑商品' : '添加商品'}</h3>
                <div className="form-container">
                  <label className="form-label">商品名称</label>
                  <input type="text" placeholder="请输入商品名称" value={productForm.name} onChange={e => setProductForm({...productForm, name: e.target.value})} />
                  <label className="form-label">所需积分</label>
                  <input type="number" placeholder="请输入所需积分" value={productForm.price} onChange={e => setProductForm({...productForm, price: parseInt(e.target.value) || 0})} />
                  <label className="form-label">库存</label>
                  <input type="number" placeholder="请输入库存数量" value={productForm.stock} onChange={e => setProductForm({...productForm, stock: parseInt(e.target.value) || 0})} />
                  <label className="form-label">描述</label>
                  <textarea placeholder="请输入商品描述" value={productForm.description} onChange={e => setProductForm({...productForm, description: e.target.value})} />
                  <label className="form-label">商品图片</label>
                  <div className="product-image-upload">
                    <input
                      type="file"
                      id="product-image-upload"
                      accept="image/jpeg,image/png,image/gif,image/webp"
                      onChange={handleProductImageUpload}
                      disabled={productImageUploading}
                      className="product-image-file-input"
                    />
                    <label htmlFor="product-image-upload" className="lively-btn product-image-upload-btn">
                      {productImageUploading ? '上传中...' : '本地上传图片'}
                    </label>
                    <span className="product-image-upload-hint">支持 JPG、PNG、GIF、WEBP</span>
                  </div>
                  <input
                    type="text"
                    placeholder="或手动输入图片 URL"
                    value={productForm.image_url}
                    onChange={e => setProductForm({ ...productForm, image_url: e.target.value })}
                  />
                  {productForm.image_url && (
                    <div className="image-preview">
                      <img src={getProductImagePreviewSrc(productForm.image_url)} alt="商品图片" className="product-image-preview" />
                    </div>
                  )}
                  <label className="form-label">详情图片URL（多个用逗号分隔）</label>
                  <input type="text" placeholder="请输入详情图片URL，多个用逗号分隔" value={productForm.detail_images} onChange={e => setProductForm({...productForm, detail_images: e.target.value})} />
                  {productForm.detail_images && (
                    <div className="detail-images-preview">
                      {productForm.detail_images.split(',').filter(url => url.trim()).map((url, index) => (
                        <img key={index} src={url.trim()} alt={`详情图${index + 1}`} className="detail-image-preview" />
                      ))}
                    </div>
                  )}
                  <div className="modal-actions">
                    <button className="lively-btn confirm-btn" onClick={editingProduct ? handleUpdateProduct : handleCreateProduct}>{editingProduct ? '更新' : '创建'}</button>
                    <button className="lively-btn cancel-btn" onClick={() => { setShowProductModal(false); setEditingProduct(null); }}>取消</button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </>
      )}

      {customConfirm.show && (
        <div className="modal-overlay" onClick={() => setCustomConfirm({ show: false, message: '', action: null })}>
          <div className="modal-content lively-modal custom-confirm-modal" onClick={e => e.stopPropagation()}>
            <h3 className="modal-title">确认操作</h3>
            <div className="form-container">
              <p className="confirm-message">{customConfirm.message}</p>
              <div className="modal-actions">
                <button className="lively-btn confirm-btn danger" onClick={() => {
                  const action = customConfirm.action;
                  setCustomConfirm({ show: false, message: '', action: null });
                  if (action) action();
                }}>确定</button>
                <button className="lively-btn cancel-btn" onClick={() => setCustomConfirm({ show: false, message: '', action: null })}>取消</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

function OrderManagement() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showShipModal, setShowShipModal] = useState(false);
  const [shippingOrder, setShippingOrder] = useState(null);
  const [shipForm, setShipForm] = useState({ deliveryCompany: '', deliveryNumber: '' });
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastType, setToastType] = useState('success');

  const getAdminHeaders = () => {
    const headers = { 'Content-Type': 'application/json' };
    const token = localStorage.getItem('token');
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    return headers;
  };

  const showToastMessage = (message, type = 'success') => {
    setToastMessage(message);
    setToastType(type);
    setShowToast(true);
    setTimeout(() => setShowToast(false), 3000);
  };

  const fetchOrders = async () => {
    setLoading(true);
    try {
      const res = await fetch('/api/admin/orders', { headers: getAdminHeaders() });
      const data = await res.json();
      setOrders(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error('Failed to load orders', error);
      setOrders([]);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchOrders();
  }, []);

  const handleShipOrder = (order) => {
    setShippingOrder(order);
    setShipForm({ deliveryCompany: '', deliveryNumber: '' });
    setShowShipModal(true);
  };

  const confirmShipOrder = async () => {
    if (!shippingOrder) return;
    if (!shipForm.deliveryCompany || !shipForm.deliveryNumber) {
      showToastMessage('请填写快递公司和快递单号', 'error');
      return;
    }
    try {
      const res = await fetch(`/api/admin/order`, {
        method: 'PUT',
        headers: getAdminHeaders(),
        body: JSON.stringify({
          id: shippingOrder.id,
          status: 'shipped',
          deliveryCompany: shipForm.deliveryCompany,
          deliveryNumber: shipForm.deliveryNumber
        })
      });
      if (res.ok) {
        showToastMessage('发货成功！', 'success');
        setShowShipModal(false);
        setShippingOrder(null);
        fetchOrders();
      } else {
        showToastMessage('发货失败', 'error');
      }
    } catch (error) {
      console.error('Failed to ship order', error);
      showToastMessage('发货失败，请重试', 'error');
    }
  };

  const handleDeleteOrder = async (orderId) => {
    try {
      const res = await fetch(`/api/admin/order/${orderId}`, {
        method: 'DELETE',
        headers: getAdminHeaders()
      });
      if (res.ok) {
        showToastMessage('订单已删除', 'success');
        fetchOrders();
      }
    } catch (error) {
      console.error('Failed to delete order', error);
      showToastMessage('删除失败', 'error');
    }
  };

  const getStatusLabel = (status) => {
    const statusMap = {
      'pending': '待处理',
      'shipped': '已发货',
      'completed': '已完成'
    };
    return statusMap[status] || status || '未知状态';
  };

  const getStatusClass = (status) => {
    return `order-status-${status}` || '';
  };

  return (
    <div className="order-management">
      {showToast && (
        <div className={`admin-toast admin-toast-${toastType}`}>
          {toastMessage}
        </div>
      )}
      <h3>订单管理</h3>
      {loading ? <p>加载中...</p> : (
        orders.length === 0 ? <p>暂无订单</p> : (
          <table className="orders-table">
            <thead>
              <tr>
                <th>订单ID</th>
                <th>用户ID</th>
                <th>商品ID</th>
                <th>数量</th>
                <th>总积分</th>
                <th>收货地址</th>
                <th>状态</th>
                <th>下单时间</th>
                <th>快递信息</th>
                <th>操作</th>
              </tr>
            </thead>
            <tbody>
              {orders.map(order => (
                <tr key={order.id}>
                  <td>{order.id}</td>
                  <td>{order.userId}</td>
                  <td>{order.productId}</td>
                  <td>{order.quantity}</td>
                  <td>{order.totalPrice}</td>
                  <td>{order.address ? (order.address.length > 20 ? order.address.substring(0, 20) + '...' : order.address) : '-'}</td>
                  <td>
                    <span className={`status-badge ${getStatusClass(order.status)}`}>
                      {getStatusLabel(order.status)}
                    </span>
                  </td>
                  <td>{order.orderTime ? new Date(order.orderTime).toLocaleString() : '-'}</td>
                  <td>
                    {order.deliveryCompany && order.deliveryNumber ? (
                      <span>{order.deliveryCompany} {order.deliveryNumber}</span>
                    ) : '-'}
                  </td>
                  <td>
                    {order.status === 'pending' && (
                      <button className="ship-btn" onClick={() => handleShipOrder(order)}>发货</button>
                    )}
                    <button className="delete-btn" onClick={() => handleDeleteOrder(order.id)}>删除</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )
      )}

      {showShipModal && shippingOrder && (
        <div className="modal-overlay" onClick={() => { setShowShipModal(false); setShippingOrder(null); }}>
          <div className="modal-content lively-modal ship-modal" onClick={e => e.stopPropagation()}>
            <h3 className="modal-title">订单发货</h3>
            <div className="form-container">
              <p className="ship-order-info">订单ID: <strong>{shippingOrder.id}</strong></p>
              <label className="form-label">快递公司</label>
              <input
                type="text"
                placeholder="请输入快递公司名称"
                value={shipForm.deliveryCompany}
                onChange={e => setShipForm({ ...shipForm, deliveryCompany: e.target.value })}
              />
              <label className="form-label">快递单号</label>
              <input
                type="text"
                placeholder="请输入快递单号"
                value={shipForm.deliveryNumber}
                onChange={e => setShipForm({ ...shipForm, deliveryNumber: e.target.value })}
              />
              <div className="modal-actions">
                <button className="lively-btn confirm-btn" onClick={confirmShipOrder}>确认发货</button>
                <button className="lively-btn cancel-btn" onClick={() => { setShowShipModal(false); setShippingOrder(null); }}>取消</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Admin;
